

import { Component, OnInit } from '@angular/core';
import { SearchParams } from '../../../search/models/search-params.model';
import { DataTableEditorService } from '../../../search/results/data-table-editor.service';
import { DataTableConfig } from '../../../search/models/data-table-config';
import { SearchStatus } from '../../../search/models/search-status.model';
import { SearchEvent } from '../../../search/models/search-event';
import { NEW_SEARCH_EVENT } from '../../../search/search-constants';
import { SearchCriteria, Clause, Condition } from '../../../search/models/search-filter-model';
import { SearchService } from '../../../search/search.service';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { ModalService } from '../../../services/modal.service';
import { SharedServiceRegistry } from '../../../shared-service-registry';
import { AlertService } from 'sce-core';
import { ReshipCellRendererComponent } from '../../wave-ship-reship-popup/custom-cell-renderers/reship-cell-renderer/reship-cell-renderer.component';
import { WaveControlDataService } from '../../../../features/outbound/wave-summary/services/wave-control-data.service';

@Component({
  selector: 'lfwms-wave-finalize-summary-popup',
  templateUrl: './wave-finalize-summary-popup.component.html',
  styleUrls: ['./wave-finalize-summary-popup.component.css']
})
export class WaveFinalizeSummaryPopupComponent implements OnInit {
  public lookupSearchService: SearchService;
  private _primaryKeyWarningNoMap = {}; // will be used for re-finalize operation.
  private _waveKey: string ;
  private _primaryKeyName: string ;
  private _primarKeysList: string[];
  private dataService : WaveControlDataService;

  constructor(public modalService: ModalService,
     public coreServiceRegistry: CoreServiceRegistry,
     private sharedServiceRegistry: SharedServiceRegistry,
     private alertService: AlertService) { }
  ngOnInit() {
  }
 /*  Finalize operation is impelmented as loadByPAge call
    that returns Finalize action status as table data.
 */
public initializeComponents(waveControlDataService : WaveControlDataService, primaryKeyName: string, primaryKeysList: string[]) {
  this._waveKey = waveControlDataService.waveIdValue;
  this._primaryKeyName = primaryKeyName;
  this._primarKeysList = primaryKeysList;
  this.dataService = waveControlDataService;

    // initialize the table and search context */
    this.initializeLookupSearchContext();
    // call the finalize loadbypage for doing finalize action.
    this._doFinalizeAndGetResponseTableData(waveControlDataService.waveIdValue, primaryKeyName, primaryKeysList);
  }

  /* initialize the table and search context */
  public initializeLookupSearchContext() {
    const searchParams: SearchParams = new SearchParams();
    searchParams.tableId = 'WAVEFINALIZETD';
    searchParams.isFullFetch = true;
    searchParams.columnCount = 15; ///???
    // searchParams.idProperty = '';
    /* Data editor is needed  for tableheader filter to work.
     Filter might misbehave if datatype is not set properly in metdata from db. */
    searchParams.tableEditor = new DataTableEditorService(this.coreServiceRegistry, this.sharedServiceRegistry);
    //   searchParams.alertService = this.alertService;
    // Client side pagination enabled
    searchParams.paginateLocally = true;
    // searchParams.defaultPageSize = 100;
    // searchParams.actionButtons =
    const tableConfig: DataTableConfig = new DataTableConfig();
    tableConfig.defaultCellRenderer = ReshipCellRendererComponent; // Re-using same component as implementation is same.
    tableConfig.enablePagination = true;
    tableConfig.enableFilter = true;
    searchParams.dataTableConfig = tableConfig;
    const searchStatus: SearchStatus = new SearchStatus();
    this.lookupSearchService = this.sharedServiceRegistry.createSearchService(searchParams, searchStatus);
  }
  /*
  Finalize API call and get response as loadBypage call.
    - set primarykey->warningNo mapping from response for use in reFinalize calls [ Implemented similar to SHip.Not explicitely asked]
    - clears the search criteria used for loadBypage request
      since it will conflict with logic for localpagination's paging, sort, filter etc.
  */
  private _doFinalizeAndGetResponseTableData(waveKey: string, primaryKeyName: string, primaryKeysList: string[]) {
    this.lookupSearchService.clearSearchStatus();
    /* above call required to clear of unexpected behaviour
   -not sending backend calls from second time when multiple parellel requests are sent */
    this.lookupSearchService.setSearchCriteria(this._getNewSearchCriteria(waveKey, primaryKeyName, primaryKeysList));
    // this.lookupSearchService.performSearch();
    // subscribe needed as we need to set primarykey->warningNo mapping and clear search criteria;
    this.lookupSearchService.fetchSearchResults()
      .subscribe((data: any) => {
        this.lookupSearchService.searchStatus.hasResults = true;
        this.lookupSearchService.searchStatus.recordCount = this.lookupSearchService.pagedData.pageDefinition.recordCount;
        const event = new SearchEvent(NEW_SEARCH_EVENT);
        event.isSearchSuccess = true;
        this.lookupSearchService.publishEvent(event);

        /* Save the warningNo received from finalze-response against each kEY
        This is requried in case of resfinalze operation */
        this.lookupSearchService.getAllRows().forEach(row => {
        this._primaryKeyWarningNoMap[row.cells[primaryKeyName].cVal] = row.cells['warningNo'].cVal;
        });
        // Clear search criteria to work with localPAgination
        this.lookupSearchService.setSearchCriteria(new SearchCriteria());
        //LFWM-3446 relaoding the shipref or loadtab after finalizing
        if(primaryKeyName === 'mbolKey'){
          this.dataService.retrieveShipRefTabData(primaryKeysList[0]);
        }else if(primaryKeyName === 'loadKey'){
          this.dataService.retrieveLoadTabData(primaryKeysList[0]);
        }
      });
    }

  /*
  Create custom search criteria for finalizing multiple mbol/load keys.
  wavekey value is also required even if finalize is done with values in primaryKeyList.
  ** (Custom loadByPage request manipulation is done at backend
    as a specific case for finalize operation )
  */
  private _getNewSearchCriteria(waveKey: string, primaryKeyName: string, primaryKeysList: string[]) {
     const searchCriteria = new SearchCriteria();
    // Function snippet to reuse clause creation within this method
    const _createSearchClause = (columName: string, value: any) => {
      const clause = new Clause();
      clause.operation = '=';
      clause.column = columName;
      clause.value = value;
      clause.logicalOperation = 'AND';
      return clause;
    };
    if (primaryKeysList.length > 0) {
      primaryKeysList.forEach(loadOrMbolKey => {
        /* Multiple keys needs to be sent in separate searchCondition,
        one searchCondition per Key */
        const searchCondition = new Condition();
        searchCondition.isMandatory = true;
        searchCondition.operator = 'OR';
        searchCondition.clauses = []; // Initialize clauses array
        searchCondition.clauses.push(_createSearchClause('waveKey', waveKey));
        searchCondition.clauses.push(_createSearchClause(primaryKeyName, loadOrMbolKey));
        searchCondition.clauses.push(_createSearchClause('keyCount', 0)); // Always 0
        const warningNo = this._primaryKeyWarningNoMap[loadOrMbolKey] ? this._primaryKeyWarningNoMap[loadOrMbolKey] : 0;
        searchCondition.clauses.push(_createSearchClause('warningNo', warningNo)); // Always 1 first and take from prev response for reship
        searchCondition.clauses.push(_createSearchClause('proceedWithWarning', 0)); // Always 0
        searchCondition.clauses.push(_createSearchClause('errorGroupKey', 0)); // Always 0
        // searchCondition.clauses.push(_createSearchClause('isMbolShip', 'Y'));
       // searchCondition.clauses.push(_createSearchClause('shipMode', 'MBOL'));
        searchCriteria.conditions.push(searchCondition);
      });
    }
    return searchCriteria;
  }
  /*
  ReFinalize the selected Keys.
  needs warningNo to be updated from the previous  call response.
  This is done by mapping primaryKeyWarningNoMap[primaryKey]
   created from the previous finalize operation subscribe end.
  */
  public reFinalize() {
    const loadOrMbolKeysToReFinalize = [];
    this.lookupSearchService.getSelectedRows().forEach(row => {
      loadOrMbolKeysToReFinalize.push(row.cells[this._primaryKeyName].cVal);
    });
    // Call ship with wavekey and MBOLkey list.
    // Only zero selection validation needed here.
    if (loadOrMbolKeysToReFinalize.length === 0) {
      // alert no shippable mbolKeys selected
      this.alertService.error(this.coreServiceRegistry.resourceService.get('no_finalizable_keys'));
      // return control.
      return;
    }
    this._doFinalizeAndGetResponseTableData(this._waveKey, this._primaryKeyName, loadOrMbolKeysToReFinalize);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/wave-control-popups/wave-finalize-summary-popup/wave-finalize-summary-popup.component.ts